import { GeneratedAnswer } from '@repo/backend-api-spec';
import { LpRIDWoord } from '../../../../typings/schema';
import { TKlankSwitchAnswer } from '../../../mechanics/rid-klank-switch/rid-klank-switch';

/** The answer for the word at `index` of `words`: 100 when it was switched right on the first try, 0 otherwise. */
export function klankSwitchAnswer(words: LpRIDWoord[], { index, correct }: TKlankSwitchAnswer): GeneratedAnswer {
  return { dataInstanceUid: words[index].uid, accuracy: correct ? 100 : 0 };
}
